// Group visibility / join-mode. Matches DOCS/logic/identity/groups.md §3.
import { z } from 'zod';
export const GroupVisibility = z.enum([
    /** Anyone joins instantly. */
    'open',
    /** Visible in directory; moderator approves each request. */
    'request',
    /** Tokenised invite link required. */
    'invite-only',
    /** Admin assignment only — not browsable. */
    'closed',
]);
//# sourceMappingURL=visibility.js.map